/* lystia-cart-promo.js - промокод у шторці кошика (T-E5-04, parity/cart.md §2.4, A-038). Custom element <lystia-cart-promo>.
   Стан Applied = прапорець localStorage `lystia:promo` (document.lystia.store 'promo' = код, спільний з промо-смугою T-E2-12) + подія lystia:promo-change {code, applied}.
   Застосування FIRST10 (код з налаштувань): фоновий GET /discount/{код} (cookie discount_code для чекаута) -> прапорець -> тост.
   Інші коди не перевіряються (Q-PROMOX OPEN) -> «Код не діє…» + shake.
   Після /discount/{код} Shopify рахує знижку в кошику сам (cfg.serverApplied) - шторка перемальовується з сервера (lystiaCartDrawer.refresh()).
   Якщо прапорець є, а сервер знижки не врахував - клієнтський перерахунок (MutationObserver на панелі патчить підвал і смугу доставки:
   «Знижка», «Разом», примітка, кнопка при мінімумі). «Прибрати»: прапорець + POST /cart/update.js {discount:''} (знімає код у кошику) + refresh.
   API: document.lystiaCartPromo { applied(), percent(), discount(totalCents) } (копійки). */
(function () {
  'use strict';
  var core = document.lystia;
  if (!core) { console.error('[lystia-cart-promo] потрібен lystia-core.js'); return; }
  if (document.lystiaCartPromo) return;

  var STORE_KEY = 'promo';
  var ui = { open: false, error: false, value: '', shake: false }; /* cartUI з прототипу; скидається при закритті шторки */

  function cfgOf(root) {
    var s = root.querySelector('script[data-promo-cfg]');
    if (!s) return null;
    try { return JSON.parse(s.textContent); } catch (e) { return null; }
  }
  function isApplied(cfg) {
    return !!cfg && (cfg.serverApplied || appliedCode(cfg.code));
  }
  function appliedCode(code) {
    var v = core.store.get(STORE_KEY, null);
    return !!v && String(v).toUpperCase() === String(code).toUpperCase();
  }
  /* знижка в копійках: ціла гривня, як round(subtotal * pct) у прототипі */
  function discountOf(total, percent) {
    return Math.round((total / 100) * percent / 100) * 100;
  }
  function money(cents, cur) {
    var n = String(Math.round(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return n + ' ' + cur;
  }
  function fill(str, map) {
    return str.replace(/\{(\w+)\}/g, function (m, k) { return k in map ? map[k] : m; });
  }

  /* ---------- підвал і смуга доставки: перерахунок після знижки ---------- */
  function patch(panel) {
    var el = panel.querySelector('lystia-cart-promo');
    var cfg = el && (el._cfg || cfgOf(el));
    if (!cfg || cfg.serverApplied || !appliedCode(cfg.code)) return;
    var disc = discountOf(cfg.total, cfg.percent);
    var total = Math.max(0, cfg.total - disc);
    var sig = [cfg.code, cfg.total, total].join(':');
    var cur = cfg.currency;
    var S = cfg.s;
    var th = money(cfg.free, cur);
    var mn = money(cfg.min, cur);

    var foot = panel.querySelector('[data-cart-footer]');
    if (foot && foot.getAttribute('data-promo-sig') !== sig) {
      foot.setAttribute('data-promo-sig', sig);
      var num = foot.querySelector('.cp-foot__sum .cp-foot__num');
      if (num) num.textContent = money(total, cur);
      var sum = foot.querySelector('.cp-foot__sum');
      if (sum && !foot.querySelector('.cp-foot__disc') && disc > 0) {
        var p = document.createElement('p');
        p.className = 'cp-foot__disc';
        var l = document.createElement('span');
        l.textContent = S.disc;
        var v = document.createElement('span');
        v.className = 'cp-foot__val';
        var sk = document.createElement('span');
        sk.className = 'cp-sk cp-sk--sm';
        sk.setAttribute('aria-hidden', 'true');
        var n2 = document.createElement('span');
        n2.className = 'cp-foot__num';
        n2.textContent = '−' + money(disc, cur);
        v.appendChild(sk); v.appendChild(n2);
        p.appendChild(l); p.appendChild(v);
        sum.parentNode.insertBefore(p, sum);
      }
      var ok = total >= cfg.min;
      var note = foot.querySelector('.cp-foot__note');
      if (note) {
        note.classList.toggle('is-warn', !ok);
        if (!ok) note.textContent = fill(S.noteMin, { min: mn, left: money(cfg.min - total, cur) });
        else note.textContent = (cfg.free > 0 && total >= cfg.free) ? S.noteFree : S.noteCalc;
      }
      var btn = foot.querySelector('[data-cart-checkout]');
      if (btn && btn.tagName === 'BUTTON') {
        btn.disabled = !ok;
        if (!ok) btn.setAttribute('aria-disabled', 'true'); else btn.removeAttribute('aria-disabled');
      }
    }

    var pr = panel.querySelector('[data-cart-progress]');
    if (pr && pr.getAttribute('data-promo-sig') !== sig) {
      pr.setAttribute('data-promo-sig', sig);
      var title, noteText, pct, cls = '', icon = 'truck';
      if (total < cfg.min) {
        title = fill(S.leftMin, { left: money(cfg.min - total, cur) });
        noteText = fill(S.noteMinFree, { min: mn, threshold: th });
        pct = cfg.min ? total / cfg.min : 0; cls = 'is-min';
      } else if (cfg.free > 0 && total >= cfg.free) {
        title = fill(S.freeActive, { threshold: th });
        noteText = S.noteShip; pct = 1; cls = 'is-free'; icon = 'check';
      } else {
        title = fill(S.leftFree, { left: money(cfg.free - total, cur) });
        noteText = fill(S.noteMinDone, { min: mn, threshold: th });
        pct = cfg.free ? total / cfg.free : 0;
      }
      pct = Math.min(1, Math.max(0, pct));
      pr.classList.remove('is-min', 'is-free');
      if (cls) pr.classList.add(cls);
      var ttl = pr.querySelector('.cp-progress__title span');
      if (ttl) ttl.textContent = title;
      var nt = pr.querySelector('.cp-progress__note');
      if (nt) nt.textContent = noteText;
      var bar = pr.querySelector('.cp-bar');
      if (bar) {
        bar.setAttribute('aria-valuenow', String(Math.round(pct * 100)));
        var fillEl = bar.querySelector('span');
        if (fillEl) fillEl.style.transform = 'scaleX(' + pct.toFixed(4) + ')';
      }
      var tt = pr.querySelector('.cp-progress__title');
      var tpl = el.querySelector('template[data-promo-icons]');
      var src = tpl && tpl.content && tpl.content.querySelector('[data-icon="' + icon + '"] svg');
      var old = tt && tt.querySelector('svg');
      if (src && old) old.replaceWith(src.cloneNode(true));
    }
  }

  var observer = null;
  function watch(panel) {
    unwatch();
    if (!panel) return;
    patch(panel);
    observer = new MutationObserver(function () { patch(panel); });
    observer.observe(panel, { childList: true, subtree: true });
  }
  function unwatch() {
    if (observer) observer.disconnect();
    observer = null;
  }
  function refreshDrawer() {
    if (document.lystiaCartDrawer) document.lystiaCartDrawer.refresh();
  }

  class LystiaCartPromo extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      this._cfg = cfgOf(this);
      this.code = this.dataset.code;
      this.def = this.querySelector('[data-st="default"]');
      this.form = this.querySelector('[data-st="form"]');
      this.okEl = this.querySelector('[data-st="applied"]');
      this.fieldEl = this.querySelector('.field');
      this.input = this.querySelector('.field__input');
      this.err = this.querySelector('.cp-promo__err');
      if (this.input) {
        this.input.setAttribute('autocapitalize', 'characters');
        this.input.setAttribute('aria-label', this.querySelector('.cp-eyebrow').textContent.trim());
        this.input.addEventListener('input', () => this.onInput());
        this.input.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); this.tryApply(this.input.value); } });
      }
      if (this._cfg && this._cfg.serverApplied && !appliedCode(this.code)) {
        /* код уже в кошику на сервері (інший пристрій/сесія) - вирівняти прапорець без повторного оновлення шторки */
        core.store.set(STORE_KEY, this.code);
        core.emit('promo-change', { code: this.code, applied: true, silent: true });
      }
      this.querySelector('[data-promo-first]').addEventListener('click', () => this.tryApply(this.code));
      this.querySelector('[data-promo-submit]').addEventListener('click', () => this.tryApply(this.input ? this.input.value : ''));
      this.querySelector('[data-promo-open]').addEventListener('click', () => this.openForm());
      this.querySelector('[data-promo-cancel]').addEventListener('click', () => this.cancel());
      this.querySelector('[data-promo-remove]').addEventListener('click', () => this.remove());
      this.render();
    }

    disconnectedCallback() { this._init = false; }

    render() {
      var applied = isApplied(this._cfg);
      var form = !applied && (ui.open || ui.error);
      this.classList.toggle('is-applied', applied);
      this.classList.toggle('is-form', form);
      this.def.hidden = applied || form;
      this.form.hidden = !form;
      this.okEl.hidden = !applied;
      if (!form) return;
      this.input.value = ui.value;
      this.fieldEl.classList.toggle('is-error', ui.error);
      this.err.hidden = !ui.error;
      this.err.textContent = ui.error ? this._cfg.error : '';
      if (ui.error) this.input.setAttribute('aria-describedby', this.err.id); else this.input.removeAttribute('aria-describedby');
      if (ui.shake) {
        ui.shake = false;
        var f = this.fieldEl;
        f.classList.add('shake');
        f.addEventListener('animationend', function () { f.classList.remove('shake'); }, { once: true });
      }
    }

    onInput() {
      ui.value = this.input.value;
      if (ui.error) { ui.error = false; this.fieldEl.classList.remove('is-error'); this.err.hidden = true; this.err.textContent = ''; this.input.removeAttribute('aria-describedby'); }
    }

    openForm() {
      ui.open = true;
      this.render();
      if (core.device() === 'desktop' && this.input) { try { this.input.focus(); } catch (e) { /* ignore */ } }
    }

    cancel() {
      ui.open = false; ui.error = false; ui.value = '';
      this.render();
    }

    tryApply(raw) {
      var code = String(raw || '').trim().toUpperCase();
      if (code !== this.code.toUpperCase()) {
        ui.error = true; ui.value = String(raw || '').trim(); ui.open = true; ui.shake = true;
        this.render();
        return;
      }
      ui.error = false; ui.open = false; ui.value = '';
      this.commit();
    }

    commit() {
      var self = this;
      var href = this.dataset.href;
      var btns = this.querySelectorAll('button');
      Array.prototype.forEach.call(btns, function (b) { b.disabled = true; });
      var done = function () {
        core.store.set(STORE_KEY, self.code);
        core.emit('promo-change', { code: self.code, applied: true });
        if (document.lystiaToast) document.lystiaToast.show(self._cfg.toast, { icon: 'check' });
      };
      if (!window.fetch) { window.location.href = href; return; }
      fetch(href, { credentials: 'same-origin', redirect: 'manual' }).then(done).catch(function () { window.location.href = href; });
    }

    remove() {
      ui.open = false; ui.error = false; ui.value = '';
      Array.prototype.forEach.call(this.querySelectorAll('button'), function (b) { b.disabled = true; });
      core.store.remove(STORE_KEY);
      try { document.cookie = 'discount_code=; Max-Age=0; path=/'; } catch (e) { /* ignore */ }
      var done = function () { core.emit('promo-change', { code: null, applied: false }); };
      if (!window.fetch) { done(); return; }
      fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: '' }) })
        .then(done).catch(done);
    }
  }

  if (!customElements.get('lystia-cart-promo')) customElements.define('lystia-cart-promo', LystiaCartPromo);

  /* зміна прапорця (цей блок, промо-смуга, інша вкладка) -> шторка перемальовується з сервера, потім патчиться */
  core.on('promo-change', function (d) {
    if (d && d.silent) return;
    if (document.lystiaOverlay && document.lystiaOverlay.isOpen('cart')) refreshDrawer();
  });
  window.addEventListener('storage', function (e) {
    if (e.key === 'lystia:promo' && document.lystiaOverlay && document.lystiaOverlay.isOpen('cart')) refreshDrawer();
  });
  core.on('overlay-open', function (d) {
    if (d && d.name === 'cart') watch(d.panel || document.lystiaOverlay.panel());
  });
  core.on('overlay-close', function (d) {
    if (d && d.name === 'cart') { unwatch(); ui = { open: false, error: false, value: '', shake: false }; }
  });
  if (document.lystiaOverlay && document.lystiaOverlay.isOpen('cart')) watch(document.lystiaOverlay.panel());

  document.lystiaCartPromo = Object.freeze({
    applied: function () { var el = document.querySelector('lystia-cart-promo'); return el ? isApplied(cfgOf(el)) : !!core.store.get(STORE_KEY, null); },
    percent: function () { var el = document.querySelector('lystia-cart-promo'); var c = el && cfgOf(el); return c ? c.percent : 0; },
    discount: function (totalCents) { var el = document.querySelector('lystia-cart-promo'); var c = el && cfgOf(el); return c && !c.serverApplied && appliedCode(c.code) ? discountOf(totalCents, c.percent) : 0; },
  });
})();
